/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type InvoiceRunsQueryVariables = {
    status?: string | null;
    searchQuery?: string | null;
    page?: number | null;
    perPage?: number | null;
};
export type InvoiceRunsQueryResponse = {
    readonly invoiceRunList: {
        readonly invoiceRuns: ReadonlyArray<{
            readonly slug: string;
            readonly source: string;
            readonly fileName: string | null;
            readonly fileUrl: string | null;
            readonly emailSubject: string | null;
            readonly entityLabel: string | null;
            readonly entityReference: string | null;
            readonly entityUrl: string | null;
            readonly extractedSummary: string | null;
            readonly shipmentLinks: ReadonlyArray<{
                readonly label: string;
                readonly url: string;
            }>;
            readonly confidence: string | null;
            readonly processingStatus: string;
            readonly errorReason: string | null;
            readonly createdAt: string;
        }> | null;
        readonly totalCount: number | null;
        readonly paginationMeta: {
            readonly totalPages: number;
        } | null;
    };
};
export type InvoiceRunsQuery = {
    readonly response: InvoiceRunsQueryResponse;
    readonly variables: InvoiceRunsQueryVariables;
};



/*
query InvoiceRunsQuery(
  $status: String
  $searchQuery: String
  $page: Int
  $perPage: Int
) {
  invoiceRunList(status: $status, searchQuery: $searchQuery, page: $page, perPage: $perPage) {
    invoiceRuns {
      slug
      source
      fileName
      fileUrl
      emailSubject
      entityLabel
      entityReference
      entityUrl
      extractedSummary
      shipmentLinks {
        label
        url
      }
      confidence
      processingStatus
      errorReason
      createdAt
      id
    }
    totalCount
    paginationMeta {
      totalPages
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perPage"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v4 = [
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page"
  },
  {
    "kind": "Variable",
    "name": "perPage",
    "variableName": "perPage"
  },
  {
    "kind": "Variable",
    "name": "searchQuery",
    "variableName": "searchQuery"
  },
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "status"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileUrl",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "emailSubject",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityLabel",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityReference",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUrl",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "extractedSummary",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "InvoiceRunShipment",
  "kind": "LinkedField",
  "name": "shipmentLinks",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "confidence",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "processingStatus",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorReason",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Paginate",
  "kind": "LinkedField",
  "name": "paginationMeta",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalPages",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "InvoiceRunsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "InvoiceRunList",
        "kind": "LinkedField",
        "name": "invoiceRunList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceRun",
            "kind": "LinkedField",
            "name": "invoiceRuns",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          (v19/*: any*/),
          (v20/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "InvoiceRunsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "InvoiceRunList",
        "kind": "LinkedField",
        "name": "invoiceRunList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceRun",
            "kind": "LinkedField",
            "name": "invoiceRuns",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v19/*: any*/),
          (v20/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "57747e36dd390e0f7c34fc80d3542425",
    "id": null,
    "metadata": {},
    "name": "InvoiceRunsQuery",
    "operationKind": "query",
    "text": "query InvoiceRunsQuery(\n  $status: String\n  $searchQuery: String\n  $page: Int\n  $perPage: Int\n) {\n  invoiceRunList(status: $status, searchQuery: $searchQuery, page: $page, perPage: $perPage) {\n    invoiceRuns {\n      slug\n      source\n      fileName\n      fileUrl\n      emailSubject\n      entityLabel\n      entityReference\n      entityUrl\n      extractedSummary\n      shipmentLinks {\n        label\n        url\n      }\n      confidence\n      processingStatus\n      errorReason\n      createdAt\n      id\n    }\n    totalCount\n    paginationMeta {\n      totalPages\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'eca3bd591430f53aa5a7e03f0ce88282';
export default node;
